import styled from 'styled-components'

export const HostIconImgWrap = styled.div<{ $size?: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${(p) => `${p.$size || 48}px`};
  height: ${(p) => `${p.$size || 48}px`};
`

export const HostIconImg = styled.img`
  flex: none;
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
  filter: invert(1);
  opacity: 0.7;
  transform: translateZ(0);
`
